export default __webpack_public_path__ + "static/media/ic_smartpay.00aac295.svg";